import React, { Component } from "react";
import PropTypes from "prop-types";
import Player from "@vimeo/player";

class VimeoPlayer extends Component {
    static propTypes = {
        url: PropTypes.string,
        playing: PropTypes.bool,
        muted: PropTypes.bool,
        color: PropTypes.string,
        autoplay: PropTypes.bool,
        onPlay: PropTypes.func,
        playsinline: PropTypes.bool,
        background: PropTypes.bool
    };

    static defaultProps = {
        color: "ED423A"
    };

    componentDidUpdate(prevProps) {
        if (prevProps.url !== this.props.url) {
            this.player.loadVideo(this.props.url);
        }

        if (prevProps.playing !== this.props.playing) {
            if (this.props.playing) {
                this.player.play();
            } else {
                this.player.pause();
            }
        }

        if (prevProps.muted !== this.props.muted) {
            this.player.setVolume(this.props.muted ? 0 : 1);
        }
    }

    handleRef = ref => {
        this.ref = ref;
        if (this.ref) {

            let playerProps = {...this.props};
            delete playerProps.onPlay;

            this.player = new Player(this.ref, playerProps);

            if (this.props.onPlay) {
                this.player.on("play", this.props.onPlay);
            }
        }
    };

    render() {

        return <div className="vimeo-player" ref={this.handleRef} />;
    }
}

export default VimeoPlayer;



// WEBPACK FOOTER //
// ./src/scripts/components/VimeoPlayer.js